import headerBackground from "../../Assets/Images/header-background-app.png";
import { useLocation } from "react-router-dom";
import ballerzLogo from "../../Assets/Images/ballerz-logo-white.png";
import homeIcon from "../../Assets/Images/home.png";
import { useParams, useNavigate } from "react-router-dom";

export default function HeaderPreRegistration(props) {
  const location = useLocation();

  const navigate = useNavigate();


  return (
    <>
      <header
        className="relative flex items-center justify-center px-8 py-16 bg-cover bg-center text-white"
        style={{
          backgroundImage: `url(${headerBackground})`,
        }}
      >


        <div className="flex justify-center">
          <img
            src={ballerzLogo}
            alt="Ballerz Logo"
            className="h-14 object-contain"
          />
        </div>
        <div className="align-middle flex flex-col items-center justify-center"></div>
      </header>
    </>
  );
}
